//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment-timezone";
import pointsservice from "../../../../services/points";
import pointName from "../../../../utils/pointName";
import unitsservice from "../../../../utils/units";

const initialState = {
	instances: {}
};


/////////
//types
export const types = {
	INIT_TABLE: "components/historytable/INIT_TABLE",
	LOAD_DATA: "components/historytable/LOAD_DATA",
	SET_TABLE_DATA: "components/historytable/SET_TABLE_DATA"
};

function initTable(state, action) {
	const id = action.payload.id;
	const component = action.payload.component;
	//do nothing if it's already init
	if (state.instances.id) {
		return state;
	}
	let tableData = {
		pointInfo: [],
		headers: [],
		rows: []
	};
	component.inputs.forEach(input => {
		if (input.type === "Dynamic") {
			input.values.forEach(value => {
				tableData.pointInfo.push({
					pointId: value,
					units: "",
					name: ""
				});
			});
		}
	});
	let newState = { ...state, instances: { ...state.instances, [id]: tableData } };
	return newState;
}

function setTableData(state, action) {
	const id = action.payload.id;
	const tableData = action.payload.tableData;
	return { ...state, instances: { ...state.instances, [id]: tableData } };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_TABLE: {
				return initTable(state, action);
			}
			case types.LOAD_DATA: {
				return state;
			}
			case types.SET_TABLE_DATA: {
				return setTableData(state, action);
			}
			default:
				return state;
		}
	}
};

function* addPointDataAsync(wkInput, pointId, coV, index) {
	if (wkInput.source === "RuleInstance") {
		return yield call(pointsservice.GetRuleInstance, pointId);
	} else if (wkInput.source === "IEnergy") {
		return yield call(pointsservice.TrendableObjectGetObject, pointId);
	}
}

function* getPointInfo(component) {
	var pointInfo = [];

	let pointDetails = [];
	for (var ii = 0; ii < component.inputs.length; ii++) {
		var wkInput = component.inputs[ii];
		if (wkInput.name != "UpperLimDeviation" && wkInput.name != "LowerLimDeviation") {
			for (var jj = 0; jj < wkInput.values.length; jj++) {
				var wkValue = wkInput.values[jj];
				const data = yield call(addPointDataAsync, wkInput, wkValue.value, wkValue.coV, jj);
				pointDetails.push(data);
			}
		}
	}

	pointDetails.forEach(point => {
		pointInfo.push({
			pointId: point.objectID,
			units: point.units,
			name: point.name,
			description: point.description
		});
	});

	return pointInfo;
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([ this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const component = payload.component;
			const id = payload.id;

			const currentSite = yield select(x => x.sitetree.currentSite);
			let utcOffset = 0;
			if(currentSite && currentSite.momentTimezone){
				 utcOffset = moment().tz(currentSite.momentTimezone).utcOffset();
			}
			let fromDate = moment().utc().subtract(1, 'years').add(utcOffset, 'm');
			let toDate = moment().utc().add(utcOffset, 'm');
			const tableData = {
				pointInfo: [],
				headers: ["Date & Time", "Status"],
				rows: []
			};
			const [failData, pointInfo] = yield all([
				call(reportsservice.GetFailureOccurrences, component.ruleInstanceId, fromDate, toDate),
				call(getPointInfo, component)
			]);
			pointInfo.forEach(info => {
				tableData.headers.push(pointName.formatDescription(info));
			});
			if (failData && failData.length) {
				for (var ii = 0; ii < failData.length; ii++) {
					var wkData = failData[ii];
					let dateString = "";
					let status = "";
					switch (wkData.runState) {
						case 1: //test start
							status = "Start";
							dateString = moment.utc(wkData.startSiteLocal).format("DD MMM hh:mma");
							break;
						case 3: //rule fail
							status = "Fail";
							dateString =
								moment.utc(wkData.startSiteLocal).format("DD MMM hh:mma") +
								" - " +
								moment.utc(wkData.endSiteLocal).format("DD MMM hh:mma");
							break;
						case 5: //test end
							status = "End";
							dateString = moment.utc(wkData.startSiteLocal).format("DD MMM hh:mma");
							break;
						default:
							break;
					}
					let rowValue = {
						dateString: dateString,
						status: status,
						points: []
					};
					for (var jj = 0; jj < pointInfo.length; jj++) {
						var newRow = {
							value: "",
                            units: unitsservice.stringToSymbol(pointInfo[jj].units),
                            decimalPlaces: unitsservice.stringToDecimalPlaces(pointInfo[jj].units)
						};
						if (wkData.pointSnapshot && wkData.pointSnapshot.length) {
							let snapshot = wkData.pointSnapshot.find(
								s => s.pointId && s.pointId.toString() == pointInfo[jj].pointId
							);
							if (snapshot) {
								newRow.value = snapshot.pointValue;
							}
						}
						rowValue.points.push(newRow);
					}
					tableData.rows.push(rowValue);
				}
			}
			yield put(actions.setTableData(id, tableData));
			if(payload.onLoadComplete){
				payload.onLoadComplete();
			}
		});
	}
};

////////
//actions
export const actions = {
	initTable(id, component) {
		return {
			type: types.INIT_TABLE,
			payload: { id, component }
		};
	},
	loadData(id, component, onLoadComplete) {
		return {
			type: types.LOAD_DATA,
			payload: { id, component, onLoadComplete }
		};
	},
	setTableData(id, tableData) {
		return {
			type: types.SET_TABLE_DATA,
			payload: { id, tableData }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/HistoryTable/redux.js